<template>
  <b-col
    :class="['card-radion-button-steps', 'col-12', !isLast ? 'mb-1' : '', { 'active-class-button-radio': isActive }]"
    ref="card_radio_button"
    @click="handleClick"
  >
    <div class="background-left-proposal-radios" :ref="`backgroud_left_proposal_radios_${index}`"/>

    <div class="text-left text-gray-600">
      <div class="float-right d-flex">
        <span v-if="!is_brandme_talent" class="mr-1 avenir-bold">$ {{separatebycomma(deal.price)}} USD</span>
        <span v-else class="mr-1 avenir-bold">
          <span v-for="i in deal.range_price" :key="i">$</span>
        </span>
        <b-form-radio :value="deal"></b-form-radio>
      </div>
      <div class="d-flex align-items-center mb-1">
        <div class="networks-stack d-flex align-items-center">
          <b-avatar-group
          :overlap="(deal.user_networks || []).length > 1 ? 0.65 : 0"
          size="25"
          v-if="(deal.user_networks || []).length"
        >
          <b-avatar
            v-for="item in deal.user_networks || []"
            :key="item.uuid"
            variant="ligth"
            :id="`tooltip-network-${index}-${item.uuid}`"
            size="25"
            button
          >
            <b-img
              :src="getIconWhite(item.network)"
              :class="getIconColor(item.network, false)"
              fluid
            />

            <b-popover
              :target="`tooltip-network-${index}-${item.uuid}`"
              triggers="hover focus"
              placement="top"
              container="body"
            >
              <strong>@{{ item.username }}</strong>
            </b-popover>
          </b-avatar>
        </b-avatar-group>
        </div>
        <div class="ml-1 overflow-hidden">
          <span class="w-100 d-block avenir-bold">{{deal.title}}</span>
        </div>
      </div>
      <p class="d-flex flex-wrap">
        <span class="d-flex align-items-center mr-1">
          <b-icon icon="shield-check" class="mr-05"/>
          <span class="avenir-medium">
            {{$t('creator.licensing').find((licence) => licence.value === deal.licensing).text}}
          </span>
        </span>
      </p>

      <p class="avenir-medium" v-if="!loaded_ia">{{deal.description}}</p>
      <div v-else>
        <b-skeleton width="100%"></b-skeleton>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
      </div>
      <hr class="mb-1"/>
      <span class="w-100 mb-1 d-block">{{ $t('creator.dealFeaures') }}</span>
      <b-badge
        v-for="(feature, fIndex) in deal.features"
        :key="fIndex"
        variant="btn-characteristics"
        class="btn-characteristics mr-1 mb-1"
      >
        <feather-icon icon="CheckIcon"></feather-icon>
        {{ getTitle(feature) }}
      </b-badge>
    </div>

    <!-- Edit action -->
    <div
      class="background-button-edit"
      @click.stop="$emit('edit_deal', 'deals', deal)"
      v-if="is_avaible_to_editing && !is_in_sidebar_chat"
    >
      <h5 class="m-0 text-white animation-opacity-words">{{ $t('creator.editDeal') }}</h5>
    </div>

    <!-- Delete action -->
    <div
      class="background-button-edit"
      @click.stop="$emit('delete_deal', deal)"
      v-if="chat_uuid && !is_brand"
    >
      <h5 class="m-0 text-white animation-opacity-words">{{ $t('creator.deleteDeal') }}</h5>
    </div>
  </b-col>
</template>

<script>
import { BCol, BBadge, BFormRadio, BSkeleton, BImg, BPopover, BAvatar, BAvatarGroup } from 'bootstrap-vue'
import { separatebycomma } from '@/libs/utils/formats'
import { getImageInfluencer } from '@/libs/utils/others';
import { getIconWhite, getIconColor } from '@/libs/utils/icons';
import { getAssetUrl } from '@/libs/utils/urls';
import { isBrand } from '@/domain/user/access.domain';
import { getUserData } from '@/libs/utils/user';

export default {
  name: 'dealRadio',
  components: {
    BCol,
    BBadge,
    BFormRadio,
    BSkeleton,
    BImg,
    BPopover,
    BAvatar,
    BAvatarGroup,
  },
  model: {
    prop: 'selected',
    event: 'select',
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    is_brandme_talent: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
      default: null,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    is_avaible_to_editing: {
      type: Boolean,
      default: false,
    },
    loaded_ia: {
      type: Boolean,
      default: false,
    },
    is_in_sidebar_chat: {
      type: Boolean,
      default: false,
    },
    chat_uuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      separatebycomma,
    }
  },
  computed: {
    user_data() {
      return getUserData();
    },
    is_brand() {
      return isBrand(this.user_data);
    },
    isActive() {
      return this.selected?.uuid === this.deal?.uuid
    },
  },
  watch: {
    isActive(val) {
      if (val) {
        this.$el.classList.add('active-class-button-radio')
      } else {
        this.$el.classList.remove('active-class-button-radio')
      }
    },
  },
  mounted() {
    if (this.isActive) {
      try {
        this.$refs[`backgroud_left_proposal_radios_${this.index}`].classList.add('active-class-button-radio')
        this.radioProxy = this.deal;
      } catch (error) {
        console.error('Error adding active class on mount:', error);
      }
    }
  },
  methods: {
    getIconWhite,
    getIconColor,
    getImageInfluencer,
    getAssetUrl,
    handleClick() {
      if (!this.is_avaible_to_editing) {
        this.$emit('select', this.deal)
        this.$emit('deal_selected', this.deal)
      }
    },
    getTitle(feature) {
      if (!feature) return ''
      const result = this.$t('creator.features').find(f => f.value === feature.title)
      return result ? result.text : ''
    },
  },
}
</script>
<style scoped lang="scss">

.active-class-button-radio {
   box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}
.active-class-button-radio .background-left-proposal-radios {
  background-color: var(--primary, #7367f0) !important;
}
.networks-stack .network-item {
  border: 2px solid white;
}
.networks-stack .network-item:first-child {
  border: none;
}
.network-item {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 80%;
  }
}
.btn-characteristics {
  color: #3483fa;
  background-color: rgba(65,137,230,.15);
  padding: 8px 10px;
}
.card-radion-button-steps {
  border-radius: 1em !important;
  background-color: white;
  overflow: hidden !important;
  padding: 2em;
  border: 0.0625rem solid rgba(222,226,230,.7); 
  position: relative;
}
.card-radion-button-steps:hover {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  cursor: pointer;
  transition: 500ms;
}
.background-left-proposal-radios, .background-left-proposal-checkboxs {
  background-color: #dfdddd;
  width: 10px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0px;
}
.background-button-edit {
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  border-radius: 0.55em;
  z-index: 10;
}
.animation-opacity-words {
  opacity: 0;
}
.card-radion-button-steps:hover .background-button-edit
{
  background-color: #3b8da888;
  transition: all 500ms;
  cursor: pointer;
  backdrop-filter: blur(10px);
}
.card-radion-button-steps:hover .animation-opacity-words
{
  opacity: 1;
  transition: all 500ms;
}
.card-radion-button-steps:not(:hover) .background-button-edit, 
.card-radion-button-steps:not(:hover) .animation-opacity-words
{
  transition: all 500ms;
}
</style>